<!--
 * @Author: baoxiongfei
 * @Date: 2025-07-22 16:05:59
 * @LastEditors: baoxiongfei
 * @LastEditTime: 2026-01-21 16:37:48
 * @FilePath: /teacher-xkh-web/src/demo/answer.vue
 * @Description:
-->
<template>
  <div class="answer-wrap">
    <TopicAnswer ref="topicAnswer" />
  </div>
</template>
<script>
import TopicAnswer from '@/components/Answer/TopicAnswer.vue'
// import MockXuanZe from '@aixuexi/tksdk/topicRender/mocks/xuanze'
// import MockTianKong from '@aixuexi/tksdk/topicRender/mocks/tiankong'
// import MockPanDuan from '@aixuexi/tksdk/topicRender/mocks/panduan'
// import MockZongHe from '@aixuexi/tksdk/topicRender/mocks/zonghe'
// import MockLianCiCJ from '@aixuexi/tksdk/topicRender/mocks/lianCiCJ'
// import MockLianXian from '@aixuexi/tksdk/topicRender/mocks/lianxian'
// import MockLianXianChild from '@aixuexi/tksdk/topicRender/mocks/lianxian-child'
// import MockXuanCiTK from '@aixuexi/tksdk/topicRender/mocks/xuanCiTK'
// import MockXuanCiTKtk from '@aixuexi/tksdk/topicRender/mocks/xuanCiTK-tk'
// import MockYueDuLJ from '@aixuexi/tksdk/topicRender/mocks/yueDuLJ'
// import MockYueDuLJxz from '@aixuexi/tksdk/topicRender/mocks/yueDuLJ-zh'
// import MockYueDuLJpd from '@aixuexi/tksdk/topicRender/mocks/yueDuLJ-pd'
// import MockWanXingTK from '@aixuexi/tksdk/topicRender/mocks/wanXingTK'
// import MockJieDa from '@aixuexi/tksdk/topicRender/mocks/jieDa'
export default {
  components: {
    TopicAnswer
  },
  mounted() {
    const list = [
      // MockXuanZe,
      // MockTianKong,
      // MockPanDuan,
      // MockZongHe,
      // MockLianCiCJ,
      // MockLianXian,
      // MockLianXianChild,
      // MockXuanCiTK,
      // MockXuanCiTKtk,
      // MockYueDuLJ,
      // MockYueDuLJxz,
      // MockYueDuLJpd,
      // MockWanXingTK,
      // MockJieDa
    ]
    this.$refs.topicAnswer.topicRender(list)
  }
}
</script>
<style lang="less" scoped>
.answer-wrap {
  width: 750px;
  height: 100%;
}
</style>